/*!
 * Here comes description.
 *
 * @package tokai-univ
 */
const $ = jQuery;

/*!
 * @deps jquery
*/

const ua = window.navigator.userAgent.toLowerCase();
const isiOS = ua.indexOf( 'iphone' ) > -1 || ua.indexOf( 'ipad' ) > -1 || ( ua.indexOf( 'macintosh' ) > -1 && 'ontouchend' in document );
const body = $( 'body' );
const prevMenu = $( '.mega-menu-control .prev-menu' );

//create sub menu title & prev control item
$( window ).on( 'load', function () {
	let submenuItem = $( '#mega-menu-list .menu-item-has-children > a' );
	let titlename;
	let titleItem;
	let prevControlItem;

	submenuItem.each( function () {
		titlename = $( this ).text();
		titleItem = '<li class="sub-menu-title">' + titlename + '</li>';
		prevControlItem = '<li class="prev-list-item">前の画面に戻る</li>';
		$( this ).next( '.sub-menu' ).prepend( titleItem );
		$( this ).next( '.sub-menu' ).append( prevControlItem );
	} );

} );

//toggle mega menu
let scrollPosition;
let controlValue;
$( '[aria-controls="mega-menu"]' ).on( 'click keypress', function (){
	const megamenuElement = $( '#mega-menu' );
	controlValue = $( this ).attr( 'aria-expanded' );
	megamenuElement.attr( 'aria-hidden', controlValue );
	if ( controlValue === 'false' ) {
		if ( isiOS ) {
			scrollPosition = window.pageYOffset;
			body.css( 'position', 'fixed' );
			body.css( 'top', '-' + scrollPosition + 'px' );
			body.addClass( 'off' );
		} else {
			body.addClass( 'off' );
		}
	} else {
		if ( isiOS ) {
			body.css( 'position', '' );
			body.css( 'top', '' );
			$( window ).scrollTop( scrollPosition );
			body.removeClass( 'off' );
			megaMenuResetActiveItems();
		} else {
			body.removeClass( 'off' );
			megaMenuResetActiveItems();
		}
	}
} );

//sub menu active
$( '#mega-menu-list .menu-item-has-children > a' ).on( 'click keypress', function () {

	let childSubMenu = $( this ).next( '.sub-menu' );

	if ( ! childSubMenu.hasClass( 'current' ) ) {
		$( '#mega-menu-list .current' ).removeClass( 'current' );
		childSubMenu.addClass( 'active current' );
		childSubMenu.parent().parent().addClass( 'off' );
		$( this ).addClass( 'open' );
	} else {
		currentSubmenuOff();
	}

	if ( ! prevMenu.hasClass( 'active' ) ) {
		prevMenu.addClass( 'active' );
	}

	if ( $( this ).hasClass( 'acc-open' ) ) {
		$( this ).removeClass( 'acc-open' );
		$( this ).next( '.sub-menu' ).find( '.acc-open' ).removeClass( 'acc-open' );
	} else {
		$( this ).addClass( 'acc-open' );
	}

	return false;
} );

prevMenu.on( 'click keypress', function () {
	currentSubmenuOff();
} );

$( document ).on( 'click keypress', '.prev-list-item', function () {
	currentSubmenuOff();
} );

function currentSubmenuOff() {
	let currentItem = $( '#mega-menu-list .current.active' );
	if ( currentItem.parent().parent().hasClass( 'active' ) ){
		currentItem.parent().parent().addClass( 'current' );
		currentItem.parent().parent().removeClass( 'off' );
	} else {
		prevMenu.removeClass( 'active' );
		currentItem.parent().parent().removeClass( 'off' );
	}
	currentItem.removeClass( 'active current' );
	$( '#mega-menu-list a.open' ).removeClass( 'open' );
}

function megaMenuResetActiveItems() {
	$( '#mega-menu-list a.open' ).removeClass( 'open' );
	$( '#mega-menu-list .active' ).removeClass( 'active' );
	$( '#mega-menu-list .current' ).removeClass( 'current' );
	prevMenu.removeClass( 'active' );
}
